import { Component, OnInit, HostListener } from '@angular/core';
import { MyserviceService } from '../../provider/myservice.service';
import { ActivatedRoute, Router } from '@angular/router';
import * as moment from 'moment';
import Swal from 'sweetalert2';
import { report_bill_lang } from "../../language/report_bill";
import * as XLSX from 'xlsx-js-style';


@Component({
  selector: 'app-print-report-bill-cancel-excel',
  templateUrl: './print-report-bill-cancel-excel.component.html',
  styleUrls: ['./print-report-bill-cancel-excel.component.scss']
})
export class PrintReportBillCancelComponentExcel implements OnInit {
  @HostListener('window:afterprint', ['$event'])
  public afterPrintHandler(event) {
    window.close();
    window.stop();
    console.log('Printing finished or canceled.ๅๅๅ');
  }
  total_price = 0;
  total_price_value = '';
  print_datetime = '';
  report = '';
  day: any;
  month: any;
  year: any;
  reports: any;
  isLoading = true;
  lang = localStorage.getItem('lang') == "EN" ? "EN" : "TH";
  language: any;
  constructor(private route: ActivatedRoute, router: Router, private service: MyserviceService) {
    this.language = report_bill_lang[this.lang];
  }

  ngOnInit() {

    this.route.queryParams.subscribe(params => {
      //debugger
      if (params['report'] == '1') {
        var x = moment.unix(params['datetime']).locale('th-TH');
        var xy = 0;
        xy = parseInt(x.format('YYYY'));

        if (xy < 2500) {
          xy = xy + 543;
        }

        this.day = parseInt(x.format('DD'));
        this.month = parseInt(x.format('MM'));
        this.year = parseInt(x.format('YYYY'));
        this.print_datetime = x.format('DD MMMM ') + xy.toString();
        this.report = '1';
      }
      else if (params['report'] == '2') {
        var dateString = params['month'] + '-01-' + params['year'];
        var x = moment(dateString, 'MM-DD-YYYY').locale('th-TH');
        var xy = 0;
        xy = parseInt(x.format('YYYY'));

        if (xy < 2500) {
          xy = xy + 543;
        }

        this.day = parseInt(x.format('DD'));
        this.month = parseInt(x.format('MM'));
        this.year = parseInt(x.format('YYYY'));
        this.print_datetime = x.format('MMMM ') + xy.toString();
        console.log(this.print_datetime);
        this.report = '6';
      }
      else if (params['report'] == '3') {
        var dateString = '01-01-' + params['year'];
        var x = moment(dateString, 'MM-DD-YYYY').locale('th-TH');
        var xy = 0;
        xy = parseInt(x.format('YYYY'));

        if (xy < 2500) {
          xy = xy + 543;
        }

        this.day = parseInt(x.format('DD'));
        this.month = parseInt(x.format('MM'));
        this.year = parseInt(x.format('YYYY'));
        this.print_datetime = xy.toString();
        console.log(this.print_datetime);
        this.report = '7';
      }

    });

    this.refresh();
  }

  refresh() {
    this.service.postData({ cancel: true, report_type: this.report, day: (this.day.toString().length == 1) ? '0' + this.day.toString() : this.day.toString(), month: (this.month.toString().length == 1) ? '0' + this.month.toString() : this.month.toString(), year: this.year }, "reports-new/get_reports_all_bill").then((result: any) => {
      this.reports = JSON.parse(JSON.stringify(result.data).replace(/\:null/gi, "\:\"\""))

      var formatter = new Intl.NumberFormat('th-TH', {
        style: 'currency',
        currency: 'THB',
      });


      switch (this.report) {
        case '1':
        case '6':
        case '7':

          for (let tmb = 0; tmb <= this.reports.length - 1; tmb++) {
            this.reports[tmb].number_row = (tmb + 1).toString();

            var xy = 0;
            xy = parseInt(moment(this.reports[tmb].due_date).format('YYYY'));

            if (xy < 2500) {
              xy = xy + 543;
            }

            this.reports[tmb].due_date = moment(this.reports[tmb].due_date).format("DD/MM/") + xy;
            this.reports[tmb].pay_datetime = moment(this.reports[tmb].pay_datetime).add(543, 'y').format("DD/MM/YYYY");
            this.total_price += parseFloat(this.reports[tmb].total_price);
            this.reports[tmb].fee_type_price = formatter.format(this.reports[tmb].fee_type_price);
            this.reports[tmb].discount = formatter.format(this.reports[tmb].discount);
            this.reports[tmb].total_price = formatter.format(this.reports[tmb].total_price);
          }

          this.total_price_value = formatter.format(this.total_price);
          this.isLoading = false;
          const newArray_days = this.reports.map(report => {
            return {
              'ลำดับ': report.number_row,
              'รหัสใบเสร็จรับเงิน': report.bill_id,
              'วันที่ชำระ': report.pay_datetime,
              'รหัสที่อยู่': report.place_id,
              'ชื่อผู้เสียภาษี': report.customer_name,
              'ที่อยู่/บ้านเลขที่': report.place_address,
              'ประเภทค่าธรรมเนียม': report.fee_type_description,
              'ส่วนลด': report.discount,
              'ยอดที่ชำระ': report.total_price,
              'ประเภทการชำระเงิน': report.payment_description


              // add more key-value pairs as needed
            }
          });
          const wsxzz: XLSX.WorkSheet = XLSX.utils.json_to_sheet(newArray_days);
          for (var i in wsxzz) {
            console.log(wsxzz[i]);
            if (typeof wsxzz[i] != 'object') continue;
            let cell = XLSX.utils.decode_cell(i);

            wsxzz[i].s = {

              // styling for all cells
              font: {
                name: 'Angsana New',
                sz: "16"
              },
              alignment: {
                vertical: 'center',
                horizontal: 'center',
                wrapText: '1', // any truthy value here
              },
              border: {
                right: {
                  style: 'thin',
                  color: '000000',
                },
                left: {
                  style: 'thin',
                  color: '000000',
                },
                top: {
                  style: 'thin',
                  color: '000000',
                },
                bottom: {
                  style: 'thin',
                  color: '000000',

                }

              },
            };

            if (cell.c == 6) {
              // first column
              wsxzz[i].s.numFmt = 'DD-MM-YYYY'; // for dates
              wsxzz[i].z = 'DD-MM-YYYY';
            } else {
              wsxzz[i].s.numFmt = '00'; // other numbers
            }

            if (cell.r == 0) {
              // first row
              wsxzz[i].s.border.bottom = {
                // bottom border
                style: 'thin',
                color: '000000',
              };
            }

            if (cell.r == 0) {
              // every other row
              wsxzz[i].s.fill = {
                // background color
                patternType: 'solid',
                fgColor: { rgb: 'b2b2b2' },
                bgColor: { rgb: 'b2b2b2' },
              };
            }
          }
          const wbzxx: XLSX.WorkBook = XLSX.utils.book_new();
          wsxzz['!cols'] = [{ width: 10 }, { width: 20 }, { width: 30 }, { width: 30 }, { width: 30 }, { width: 30 }, { width: 30 }, { width: 30 }, { width: 30 }, { width: 30 }, { width: 30 }];
          XLSX.utils.book_append_sheet(wbzxx, wsxzz, 'Reports');
          XLSX.writeFile(wbzxx, `billcancel_${this.report == '1' ? 'days' : this.report == '6' ? 'month' : 'year'}.xlsx`);
          break;

        case '6':
          for (let tmb = 0; tmb <= this.reports.length - 1; tmb++) {
            this.reports[tmb].number_row = (tmb + 1).toString();
            this.total_price += parseFloat(this.reports[tmb].total_price);
            this.reports[tmb].total_price = formatter.format(this.reports[tmb].total_price);

            let x = this.service.postData({ report_type: '41', day: (this.reports[tmb].days.toString().length == 1) ? '0' + this.reports[tmb].days.toString() : this.reports[tmb].days.toString(), month: (this.month.toString().length == 1) ? '0' + this.month.toString() : this.month.toString(), year: this.year, cancel: true }, "reports-new/get_reports_all_bill").then((result2: any) => {
              //debugger;
              var res2 = JSON.parse(JSON.stringify(result2.data).replace(/\:null/gi, "\:\"\""));
              //debugger;

              if (res2.length > 0) {
                this.reports[tmb].ty01 = res2[0].ty01;
                this.reports[tmb].ty02 = res2[0].ty02;

                this.total_price_value = formatter.format(this.total_price);
                this.isLoading = false;
                const newArray_month = this.reports.map(report => {
                  return {
                    'ลำดับ': report.number_row,
                    'วันที่': report.days,
                    'ขยะมูลฝอย': report.ty01,
                    'ขยะติดเชื้อและอื่นๆ': report.ty02,
                    'จำนวนที่ออกเอกสาร': report.doc_counts,
                    'ค่าธรรมเนียม': report.total_price,
                    // add more key-value pairs as needed
                  }
                });
                const wsxzzzz: XLSX.WorkSheet = XLSX.utils.json_to_sheet(newArray_month);
                for (var i in wsxzzzz) {
                  console.log(wsxzzzz[i]);
                  if (typeof wsxzzzz[i] != 'object') continue;
                  let cell = XLSX.utils.decode_cell(i);

                  wsxzzzz[i].s = {

                    // styling for all cells
                    font: {
                      name: 'Angsana New',
                      sz: "16"
                    },
                    alignment: {
                      vertical: 'center',
                      horizontal: 'center',
                      wrapText: '1', // any truthy value here
                    },
                    border: {
                      right: {
                        style: 'thin',
                        color: '000000',
                      },
                      left: {
                        style: 'thin',
                        color: '000000',
                      },
                      top: {
                        style: 'thin',
                        color: '000000',
                      },
                      bottom: {
                        style: 'thin',
                        color: '000000',

                      }

                    },
                  };

                  if (cell.c == 6) {
                    // first column
                    wsxzzzz[i].s.numFmt = 'DD-MM-YYYY'; // for dates
                    wsxzzzz[i].z = 'DD-MM-YYYY';
                  } else {
                    wsxzzzz[i].s.numFmt = '00'; // other numbers
                  }

                  if (cell.r == 0) {
                    // first row
                    wsxzzzz[i].s.border.bottom = {
                      // bottom border
                      style: 'thin',
                      color: '000000',
                    };
                  }

                  if (cell.r == 0) {
                    // every other row
                    wsxzzzz[i].s.fill = {
                      // background color
                      patternType: 'solid',
                      fgColor: { rgb: 'b2b2b2' },
                      bgColor: { rgb: 'b2b2b2' },
                    };
                  }
                }
                const wbzxxxx: XLSX.WorkBook = XLSX.utils.book_new();
                wsxzzzz['!cols'] = [{ width: 10 }, { width: 20 }, { width: 30 }, { width: 30 }, { width: 30 }, { width: 30 }];
                XLSX.utils.book_append_sheet(wbzxxxx, wsxzzzz, 'Reports');
                XLSX.writeFile(wbzxxxx, 'billcancel_month.xlsx');
              }

            })
          }



          break;

        case '7':
          for (let tmb = 0; tmb <= this.reports.length - 1; tmb++) {
            this.reports[tmb].number_row = (tmb + 1).toString();
            this.total_price += parseFloat(this.reports[tmb].total_price);

            let x = this.service.postData({
              report_type: '51', day: (this.day.toString().length == 1) ? '0' + this.day.toString() : this.day.toString(), month: (this.reports[tmb].month.toString().length == 1) ? '0' + this.reports[tmb].month.toString() : this.reports[tmb].month.toString(), year: this.year
              , cancel: true
            }, "reports-new/get_reports_all_bill").then((result2: any) => {
              //debugger;
              var res2 = JSON.parse(JSON.stringify(result2.data).replace(/\:null/gi, "\:\"\""));
              //debugger;
              if (result2.data.length > 0) {
                this.reports[tmb].ty01 = res2[0].ty01;
                this.reports[tmb].ty02 = res2[0].ty02;
                switch (this.reports[tmb].month) {
                  case '01':
                    this.reports[tmb].month = 'มกราคม';
                    break
                  case '02':
                    this.reports[tmb].month = 'กุมภาพันธ์';
                    break
                  case '03':
                    this.reports[tmb].month = 'มีนาคม';
                    break
                  case '04':
                    this.reports[tmb].month = 'เมษายน';
                    break
                  case '05':
                    this.reports[tmb].month = 'พฤษภาคม';
                    break
                  case '06':
                    this.reports[tmb].month = 'มิถุนายน';
                    break
                  case '07':
                    this.reports[tmb].month = 'กรกฏาคม';
                    break
                  case '08':
                    this.reports[tmb].month = 'สิงหาคม';
                    break
                  case '09':
                    this.reports[tmb].month = 'กันยายน';
                    break
                  case '10':
                    this.reports[tmb].month = 'ตุลาคม';
                    break
                  case '11':
                    this.reports[tmb].month = 'พฤศจิกายน';
                    break
                  case '12':
                    this.reports[tmb].month = 'ธันวาคม';
                    break
                }
                this.reports[tmb].total_price = formatter.format(this.reports[tmb].total_price);
                this.total_price_value = formatter.format(this.total_price);
              }
              if (tmb == this.reports.length - 1) {
                this.isLoading = false;
                const newArray_year = this.reports.map(report => {
                  return {
                    'ลำดับ': report.number_row,
                    'เดือน': report.month,
                    'ขยะมูลฝอย': report.ty01,
                    'ขยะติดเชื้อและอื้นๆ': report.ty02,
                    'จำนวนที่ออกเอกสาร': report.doc_counts,
                    'ค่าธรรมเนียม': report.total_price
                    // add more key-value pairs as needed
                  }
                });
                const wsxzzz: XLSX.WorkSheet = XLSX.utils.json_to_sheet(newArray_year);
                for (var i in wsxzzz) {
                  console.log(wsxzzz[i]);
                  if (typeof wsxzzz[i] != 'object') continue;
                  let cell = XLSX.utils.decode_cell(i);

                  wsxzzz[i].s = {

                    // styling for all cells
                    font: {
                      name: 'Angsana New',
                      sz: "16"
                    },
                    alignment: {
                      vertical: 'center',
                      horizontal: 'center',
                      wrapText: '1', // any truthy value here
                    },
                    border: {
                      right: {
                        style: 'thin',
                        color: '000000',
                      },
                      left: {
                        style: 'thin',
                        color: '000000',
                      },
                      top: {
                        style: 'thin',
                        color: '000000',
                      },
                      bottom: {
                        style: 'thin',
                        color: '000000',

                      }

                    },
                  };

                  if (cell.c == 6) {
                    // first column
                    wsxzzz[i].s.numFmt = 'DD-MM-YYYY'; // for dates
                    wsxzzz[i].z = 'DD-MM-YYYY';
                  } else {
                    wsxzzz[i].s.numFmt = '00'; // other numbers
                  }

                  if (cell.r == 0) {
                    // first row
                    wsxzzz[i].s.border.bottom = {
                      // bottom border
                      style: 'thin',
                      color: '000000',
                    };
                  }

                  if (cell.r == 0) {
                    // every other row
                    wsxzzz[i].s.fill = {
                      // background color
                      patternType: 'solid',
                      fgColor: { rgb: 'b2b2b2' },
                      bgColor: { rgb: 'b2b2b2' },
                    };
                  }
                }
                const wbzxxx: XLSX.WorkBook = XLSX.utils.book_new();
                wsxzzz['!cols'] = [{ width: 10 }, { width: 20 }, { width: 30 }, { width: 30 }, { width: 30 }, { width: 30 }];
                XLSX.utils.book_append_sheet(wbzxxx, wsxzzz, 'Reports');
                XLSX.writeFile(wbzxxx, 'billcancel_year.xlsx');
              }

            })







          }


          break;
      }


    }, (err) => {
      this.isLoading = false;
      Swal.fire({
        title: this.language.no_internet_alert,
        text: '',
        type: 'error',
        showCancelButton: false,
        showConfirmButton: false,
        timer: 2000
      });
    });
  }

}
